import { addHours, format } from "date-fns";
import { useEffect, useState } from "react";
import { useMyCallsLazyQuery } from "../graphql";

const PER_PAGE = 20;

function useMyCalls(initialStartDate?: Date, initialEndDate?: Date) {
    const [{ startDate, endDate }, setQuery] = useState({
        startDate: initialStartDate,
        endDate: initialEndDate
    });

    const variables = {
        page: 1,
        pageLimit: PER_PAGE,
        where: {
            startDate: startDate ? format(startDate, "yyyy-MM-dd") : null,
            endDate: endDate ? format(addHours(endDate, 1), "yyyy-MM-dd") : null
        }
    };
    const [request, { loading, data, error, fetchMore }] = useMyCallsLazyQuery({
        variables,
        notifyOnNetworkStatusChange: true,
        fetchPolicy: "cache-and-network"
    });

    useEffect(() => {
        request();
    }, [startDate, endDate, request]);

    const refresh = ({ startDate, endDate }) => {
        setQuery({ startDate, endDate });
    };

    const loadMore = () => {
        return fetchMore({
            variables: {
                ...variables,
                page: data?.myCalls?.pageInfo?.nextPage || 1
            },
            updateQuery: (previousResult, { fetchMoreResult }) => {
                const newNodes = fetchMoreResult.myCalls.nodes;
                return newNodes.length
                    ? {
                        ...fetchMoreResult,
                        myCalls: {
                            ...fetchMoreResult.myCalls,
                            nodes: [...previousResult.myCalls.nodes, ...newNodes]
                        }
                    }
                    : previousResult;
            }
        });
    };
    return {
        totalCount: data?.myCalls?.totalCount || 0,
        items: data?.myCalls?.nodes || [],
        hasNextPage: data?.myCalls?.pageInfo?.hasNextPage,
        loading,
        loadMore,
        refresh,
        init: request
    };
}
export { useMyCalls };
